<template>
	<div>
		<hr v-if="answerInputidx > 0"/>
		<div class="item-row">
			<div class="item-cell" v-html="infoHtml"></div>
		</div>
		<div class="item-row" style="margin-top:4px">
			<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('0') ? 'button-fill':'button-outline']">
				<span class="badge color-black" v-if="isDisplayAnswer('0')">1</span> 
				<span v-else>1</span>
			</button>
			<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('1') ? 'button-fill':'button-outline']">
				<span class="badge color-black" v-if="isDisplayAnswer('1')">2</span> 
				<span v-else>2</span>
			</button>
			<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('2') ? 'button-fill':'button-outline']">
				<span class="badge color-black" v-if="isDisplayAnswer('2')">3</span> 
				<span v-else>3</span>
			</button>
			<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('3') ? 'button-fill':'button-outline']">
				<span class="badge color-black" v-if="isDisplayAnswer('3')">4</span> 
				<span v-else>4</span>
			</button>
			<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('4') ? 'button-fill':'button-outline']">
				<span class="badge color-black" v-if="isDisplayAnswer('4')">5</span> 
				<span v-else>5</span>
			</button>
		</div>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import MathLive from 'mathlive';

export default {
	props: {
		examNo: { default: 0 },
		subExamIdx: { default: 0 },
		answerInputidx: { default: 0 },
	},
	data() {
		return {
			infoHtml: "",
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		info() {
			return this.getAnswerInput().info;
		},
		answer() {
			return this.getAnswerInput().answer;
		},
		inputAnswer: {
			get() {
				return this.getAnswerInput().inputAnswer;
			},
			set(newValue) {
				var answerInput = this.getAnswerInput();
				answerInput.inputAnswer = newValue;
			}
		},
	},
	mounted() {
		this.renderInfo();
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getAnswerInput() {
			var answers = this.getCommonObj().answers;

			var examIndex = this.examNo - 1;
			var exam = answers[examIndex];
			var subExam = exam.subExamList[this.subExamIdx];
			var answerInput = subExam.answerInputList[this.answerInputidx];

			return answerInput;
		},
		isSelected(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.inputAnswer.includes(exampleNo);
		},
		isDisplayAnswer(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.mode=="SCORE" && this.answer.includes(exampleNo);
		},
		onNumberClick(e) {
			if (this.mode != "ANSWER") {
				return;
			}

			const thisButton = $(e.currentTarget);
			const parent = thisButton.parent();
			const buttons = parent.children("button");

			if (thisButton.hasClass("button-fill")) {
				thisButton.removeClass("button-fill");
				thisButton.addClass("button-outline");
			} else {
				thisButton.removeClass("button-outline");
				thisButton.addClass("button-fill");
			}

			let value = "";
			for (var i=0; i<buttons.length; i++) {
				let button = $(buttons[i]);

				if (button.hasClass("button-fill")) {
					if (value != "") {
						value = value + ".";
					}

					value = value + (i + 1);
				}
			}

			this.inputAnswer = value;
		},
		renderInfo() {
			this.infoHtml = MathLive.latexToMarkup(this.info, "displaystyle");	
		},
	}
}

</script>